import { ReduxAction, ReportProblemInitialState, ReportProblemState } from "../models";
import { ReportProblemTypes } from "../types";

export const ReportState = (state: ReportProblemState = ReportProblemInitialState, action?: ReduxAction): ReportProblemState => {
    if (!action) return state;

    switch (action.type) {
        case ReportProblemTypes.REQUEST_REPORT_PROBLEM:
            return { ...state, loading: true };
        case ReportProblemTypes.REPORT_PROBLEM_SUBMITTED:
            return { ...state, loading: false };
    }

    return state;
};
